export default "__VITE_ASSET__BaORR$KB__"